import { useRouter } from "../router";
import { TIER_PLANS } from "../pricing";
import { PlanCard } from "../components/PlanCard";
import img1 from "../assets/design/img-1.jpg";
import img2 from "../assets/design/img-2.jpg";
import img3 from "../assets/design/img-3.jpg";
import img4 from "../assets/design/img-4.jpg";

const Arrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);
const Star = () => (
  <svg viewBox="0 0 24 24">
    <polygon points="12 2 15 8.5 22 9.3 17 14 18.2 21 12 17.8 5.8 21 7 14 2 9.3 9 8.5" />
  </svg>
);
const Chevron = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const DOCTORS = [
  { name: "Dr. Jane Forester", photo: img1, specialty: "General Practitioner · MD", rating: 4.9, reviews: 2341, available: true, years: 15 },
  { name: "Dr. Marcus Reed", photo: img2, specialty: "Internal Medicine · MD", rating: 4.8, reviews: 1892, available: true, years: 12 },
  { name: "Dr. Amelia Chen", photo: img3, specialty: "Pediatrics · MD, FAAP", rating: 4.9, reviews: 1547, available: false, years: 9 },
  { name: "Dr. Sophia Patel", photo: img4, specialty: "Family Medicine · MD", rating: 4.7, reviews: 1124, available: true, years: 8 },
];

const STEPS = [
  {
    num: "Step 01",
    title: "Tell us what's going on",
    body: "Pick a reason for your visit and share any details. Symptoms, history, anything your doctor should know.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z" /></svg>
    ),
  },
  {
    num: "Step 02",
    title: "Choose your doctor",
    body: "Browse board-certified physicians. See their specialties, ratings, and availability — pick who you click with.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>
    ),
  },
  {
    num: "Step 03",
    title: "Pick your time",
    body: "Same-day visits available 24/7. Or schedule out — your doctor is on your calendar, not the other way around.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
    ),
  },
  {
    num: "Step 04",
    title: "Get care",
    body: "Join your video visit from any device. Prescriptions go to your pharmacy. Follow-ups in your inbox.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" ry="2" /></svg>
    ),
  },
];

const AI_FEATURES = [
  {
    title: "Always on",
    body: "Ask about plans, pricing, or how visits work — any hour, no waiting for office hours.",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 8v4l3 2" /></svg>,
  },
  {
    title: "Knows the plans cold",
    body: "Straight answers on what Basic, Premium, and Fighter include — so you pick the right fit.",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>,
  },
  {
    title: "Routes medical to a real doctor",
    body: "Aria never gives medical advice or interprets symptoms — anything clinical goes to a Champion Care clinician.",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>,
  },
];

const TESTIMONIALS = [
  { quote: "My doctor actually had time to talk through what I was feeling, instead of one hand on the door handle. It changed how I think about primary care.", initials: "RM", name: "Rachel M.", detail: "Premium · Member since 2024" },
  { quote: "Booked a same-day visit for my kid's ear infection and had the prescription at our pharmacy in under an hour. No urgent care waiting room. Worth every dollar.", initials: "DL", name: "David L.", detail: "Premium · parent of two" },
  { quote: "I travel constantly for work. Knowing I can see the same doctor from any time zone — and that she knows my history — is genuinely freeing.", initials: "JK", name: "Jordan K.", detail: "Premium · 18 months" },
];

const FAQS = [
  { q: "How do I schedule a visit?", a: <>Click <strong>Start your visit</strong>, choose what's going on, pick your doctor, and select a time. Most telehealth visits start in under 15 minutes.</> },
  { q: "What's covered in my plan?", a: <>Premium includes unlimited telehealth visits with any doctor in our 250-MD network, recovery and sports-psych specialists, e-prescriptions, mail-order pharmacy, and ER reimbursement up to $5,000/year. Basic covers up to 6 visits per month with the same network.</> },
  { q: "How do I cancel or reschedule an appointment?", a: <>Open your <strong>Visits</strong> page, choose the visit you'd like to change, and use the actions at the bottom. You can reschedule free of charge up to 1 hour before your visit.</> },
  { q: "Can I switch doctors?", a: <>Anytime. There are no referrals required for any specialist in your network. Just pick a different doctor on your next scheduling flow.</> },
  { q: "How do prescriptions work?", a: <>Your doctor sends prescriptions directly to your preferred pharmacy at the end of your visit. Premium members can use our mail-order pharmacy with free 2-day shipping.</> },
  { q: "Is telehealth available 24/7?", a: <>Yes. Urgent-care telehealth visits are available 24 hours a day, 7 days a week. Specialist scheduling follows their normal hours.</> },
  { q: "Is this covered by my insurance?", a: <>ChampionCare is a direct-pay membership and isn't billed through insurance. We submit prescriptions, lab orders, and referrals using your insurance information, so those services still go through your plan as usual.</> },
];

// Ported verbatim from Luan's championcare-consumer-web.html REASONS (12 items, icon + label).
const CONDITIONS = [
  { label: "Cold, flu & respiratory", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v8M12 10c-1 4-3 6-6 6-3 0-3-4-3-6 0-3 2-6 5-6h4M12 10c1 4 3 6 6 6 3 0 3-4 3-6 0-3-2-6-5-6h-4" /></svg> },
  { label: "Sinus & allergies", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" /></svg> },
  { label: "UTI", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 2.5l5 7a6 6 0 11-10 0l5-7z" /></svg> },
  { label: "Skin & rash", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="9" /><circle cx="9" cy="10" r="1" /><circle cx="15" cy="11" r="1.2" /><circle cx="11" cy="15" r="0.8" /></svg> },
  { label: "Headache & migraine", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9.5 4.5a3 3 0 00-3 3v1a3 3 0 00-2 5.5 3 3 0 002 5.5v.5a3 3 0 003 3M14.5 4.5a3 3 0 013 3v1a3 3 0 012 5.5 3 3 0 01-2 5.5v.5a3 3 0 01-3 3M12 5v15" /></svg> },
  { label: "Stomach & digestion", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="9" /><path d="M8 13c1 1.5 2.5 2 4 2s3-.5 4-2" /></svg> },
  { label: "Anxiety & mood", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 000-7.78z" /></svg> },
  { label: "Prescription refill", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-45 12 12)" /><line x1="7" y1="7" x2="17" y2="17" /></svg> },
  { label: "Lab test review", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9 3h6M10 3v6L5 19a2 2 0 002 3h10a2 2 0 002-3l-5-10V3" /></svg> },
  { label: "Annual wellness", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9 12l2 2 4-4" /><circle cx="12" cy="12" r="9" /></svg> },
  { label: "General consultation", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 11.5a8.4 8.4 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.4 8.4 0 01-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.4 8.4 0 013.8-.9h.5a8.5 8.5 0 018 8v.5z" /></svg> },
  { label: "Something else", icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="9" /><circle cx="8" cy="12" r="1" fill="currentColor" /><circle cx="12" cy="12" r="1" fill="currentColor" /><circle cx="16" cy="12" r="1" fill="currentColor" /></svg> },
];

const CheckSm = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
);

export function Home() {
  const { navigate } = useRouter();
  const scrollTo = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <>
      {/* HERO */}
      <section className="hero" id="home">
        <div className="container hero-inner">
          <div className="hero-grid">
            <div>
              <div className="eyebrow hero-eyebrow">Health Service</div>
              <h1 className="hero-title">
                Care that<br />champions <em>you.</em>
              </h1>
              <p className="hero-sub">
                Board-certified physicians, on-demand. World-class care in your corner.
              </p>
              <div className="hero-ctas">
                <button className="btn btn-primary btn-lg" onClick={() => navigate("/signup")}>
                  Start your visit
                  <Arrow />
                </button>
                <button className="btn btn-ghost btn-lg" onClick={() => scrollTo("how")}>
                  How it works
                </button>
              </div>
              <div className="hero-stats">
                <div className="hero-stat"><div className="num"><em>15</em>{" "}min</div><div className="lbl">Average wait</div></div>
                <div className="hero-stat"><div className="num"><em>50</em></div><div className="lbl">States served</div></div>
                <div className="hero-stat"><div className="num"><em>4.9</em>{" "}★</div><div className="lbl">Patient rating</div></div>
              </div>
            </div>

            <div>
              <div className="hero-visual">
                <div className="hero-glow" aria-hidden="true" />
                <div className="hero-portrait">
                  <img src={img1} alt="Dr. Jane Forester" loading="eager" />
                  <span className="hero-portrait-pulse" aria-hidden="true" />
                </div>
                <div className="hero-nameplate">
                  <div>
                    <div className="hero-nameplate-name">Dr. Jane <em>Forester</em></div>
                    <div className="hero-nameplate-spec">General Practitioner · MD</div>
                  </div>
                  <div className="hero-nameplate-rating">
                    <Star />
                    4.9
                  </div>
                </div>
                <div className="hero-visual-content">
                  <div className="hero-card">
                    <div className="hero-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg></div>
                    <div className="hero-card-text">
                      <div className="hero-card-title">You're checked in</div>
                      <div className="hero-card-desc">Today · 2:30 PM</div>
                    </div>
                  </div>
                  <div className="hero-card bottom">
                    <div className="hero-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-45 12 12)" /><line x1="7" y1="7" x2="17" y2="17" /></svg></div>
                    <div className="hero-card-text">
                      <div className="hero-card-title">Prescription sent</div>
                      <div className="hero-card-desc">To CVS — Santa Ana, CA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRUSTED PARTNERS */}
      <div className="trust-bar">
        <div className="container">
          <div className="trust-eyebrow">Powered by trusted partners</div>
          <div className="partners-row">
            <div className="partner partner-ccp">
              <span className="ccp-cross">+</span>
              <span>Convenient<em>Care Plus</em></span>
            </div>
            <div className="partner partner-cc">Care<em>Clix</em></div>
            <div className="partner partner-qd">
              <span className="qd-dot" aria-hidden="true" />
              <span>Quest<em>Diagnostics</em></span>
            </div>
            <div className="partner partner-pcarx">PCARx</div>
            <div className="partner partner-cg">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.5 3.8 10.7 9 12 5.2-1.3 9-6.5 9-12V5l-9-4z" /></svg>
              Care Guide
            </div>
            <div className="partner partner-snap">snap<em>kitchen</em></div>
            <div className="partner partner-careington">Careington<em>Solutions Simplified</em></div>
            <div className="partner partner-vsp"><em>vsp</em>vision care</div>
            <div className="partner partner-higgin">Higginbotham</div>
            <div className="partner partner-tci">True Captive<em>Insurance</em></div>
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <section className="section" id="how">
        <div className="container">
          <div className="section-head">
            <div className="eyebrow">How it works</div>
            <h2 className="h-display h2">From symptom to <em>solution</em> in minutes.</h2>
            <p>No more waiting rooms. No more phone trees. Just clear, unhurried care from a doctor who actually listens.</p>
          </div>
          <div className="steps">
            {STEPS.map((s) => (
              <div className="step" key={s.num}>
                <div className="step-num">{s.num}</div>
                <div className="step-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MOBILE APPS */}
      <section className="mobile-cta-section" id="mobile-apps">
        <div className="container">
          <div className="mobile-cta-grid">
            <div>
              <div className="mobile-cta-eyebrow">Mobile apps</div>
              <h2 className="mobile-cta-title">Care that fits in your <em>pocket.</em></h2>
              <p className="mobile-cta-lead">
                Book a visit on the bus. Get a refill from the grocery store. Message your doctor on
                your lunch break. The full ChampionCare experience — wherever you are.
              </p>
              <ul className="mobile-cta-features">
                <li><CheckSm /> Visit reminders 24 hours and 1 hour before each visit</li>
                <li><CheckSm /> Face ID / fingerprint for secure access</li>
                <li><CheckSm /> Offline access to records and visit summaries</li>
              </ul>
              <div className="store-buttons">
                <button className="store-btn" onClick={() => navigate("/signup")} aria-label="Download on the App Store">
                  <svg className="store-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" /></svg>
                  <span className="store-btn-text"><small>Download on the</small><strong>App Store</strong></span>
                </button>
                <button className="store-btn" onClick={() => navigate("/signup")} aria-label="Get it on Google Play">
                  <svg className="store-icon" viewBox="0 0 24 24"><path fill="#34A853" d="M4.36 2.04c-.21.21-.33.5-.33.85v18.22c0 .35.12.64.33.85L13.59 12 4.36 2.04z" /><path fill="#FBBC04" d="M16.4 14.81L13.6 12l2.8-2.81L20.16 11.32c.51.3.84.81.84 1.34 0 .43-.21.83-.54 1.1l-4.06 1.05z" /><path fill="#EA4335" d="M13.6 12L4.36 21.96c.31.31.78.36 1.16.13L16.4 14.81 13.6 12z" /><path fill="#4285F4" d="M13.6 12L16.4 9.19 5.52 1.91c-.38-.23-.85-.18-1.16.13L13.6 12z" /></svg>
                  <span className="store-btn-text"><small>Get it on</small><strong>Google Play</strong></span>
                </button>
              </div>
            </div>

            <div className="phone-wrap" aria-hidden="true">
              <div className="phone-frame">
                <div className="phone-notch" />
                <div className="phone-screen">
                  <div className="phone-statusbar">
                    <span>9:41</span>
                    <div className="phone-statusbar-right">
                      <svg viewBox="0 0 24 24" fill="currentColor"><rect x="2" y="14" width="3" height="6" /><rect x="7" y="11" width="3" height="9" /><rect x="12" y="8" width="3" height="12" /><rect x="17" y="4" width="3" height="16" /></svg>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M2 8.5C5 5.5 8.5 4 12 4s7 1.5 10 4.5" /><path d="M5 12c2-2 4.5-3 7-3s5 1 7 3" /><path d="M8 15.5c1.5-1.5 5-2 4 0" /><circle cx="12" cy="19" r="1.3" fill="currentColor" /></svg>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="7" width="18" height="10" rx="2" /><rect x="20" y="10" width="2" height="4" rx="0.5" fill="currentColor" /><rect x="4" y="9" width="14" height="6" rx="1" fill="currentColor" /></svg>
                    </div>
                  </div>
                  <div className="phone-content">
                    <div className="phone-greeting">Hello, <em>Alex.</em></div>
                    <div className="phone-sub">Today · May 13</div>

                    <div className="phone-visit-card">
                      <div className="phone-visit-tag">Upcoming · 2:30 PM</div>
                      <div className="phone-visit-doctor">
                        <div className="phone-visit-avatar" style={{ backgroundImage: `url(${img1})` }} />
                        <div>
                          <div className="phone-visit-name">Dr. Jane Forester</div>
                          <div className="phone-visit-time">15-min telehealth</div>
                        </div>
                      </div>
                      <span className="phone-visit-btn">
                        <svg viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3" /></svg>
                        Join now
                      </span>
                    </div>

                    <div className="phone-tile-grid">
                      <div className="phone-tile">
                        <div className="phone-tile-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg></div>
                        <div className="phone-tile-label">Book visit</div>
                        <div className="phone-tile-sub">Same-day</div>
                      </div>
                      <div className="phone-tile">
                        <div className="phone-tile-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z" /></svg></div>
                        <div className="phone-tile-label">Ask Aria</div>
                        <div className="phone-tile-sub">AI care guide</div>
                      </div>
                      <div className="phone-tile">
                        <div className="phone-tile-ic ink"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg></div>
                        <div className="phone-tile-label">Records</div>
                        <div className="phone-tile-sub">All your data</div>
                      </div>
                      <div className="phone-tile">
                        <div className="phone-tile-ic ink"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22 6 12 13 2 6" /></svg></div>
                        <div className="phone-tile-label">Messages</div>
                        <div className="phone-tile-sub">2 unread</div>
                      </div>
                    </div>
                  </div>
                  <div className="phone-tabs">
                    <div className="phone-tab active">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>
                      <span className="phone-tab-label">Home</span>
                    </div>
                    <div className="phone-tab">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                      <span className="phone-tab-label">Visits</span>
                    </div>
                    <div className="phone-tab">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z" /></svg>
                      <span className="phone-tab-label">Aria</span>
                    </div>
                    <div className="phone-tab">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4" /><path d="M4 22v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" /></svg>
                      <span className="phone-tab-label">Profile</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT WE TREAT */}
      <section className="section section-tight section-conditions">
        <div className="container">
          <div className="section-head">
            <div className="eyebrow">What we treat</div>
            <h2 className="h-display h2">A primary care office, <em>without the office.</em></h2>
            <p>From the everyday to the urgent — the same conditions your doctor has always treated, now without the commute.</p>
          </div>
          <div className="conditions-grid">
            {CONDITIONS.map((c) => (
              <button className="condition-card" key={c.label} onClick={() => navigate("/signup")}>
                <div className="condition-icon">{c.icon}</div>
                <div className="condition-label">{c.label}</div>
              </button>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 36 }}>
            <button className="btn btn-ghost" onClick={() => navigate("/signup")}>
              Start a visit
              <Arrow />
            </button>
          </div>
        </div>
      </section>

      {/* DOCTORS */}
      <section className="section" id="doctors">
        <div className="container">
          <div className="section-head">
            <div className="eyebrow">Meet the team</div>
            <h2 className="h-display h2">Physicians who <em>listen.</em></h2>
            <p>Every doctor in our network is board-certified, deeply credentialed, and chosen for the bedside manner that makes you feel actually heard.</p>
          </div>
          <div className="doctors-grid">
            {DOCTORS.map((d) => (
              <button className="doctor-card" key={d.name} onClick={() => navigate("/signup")}>
                {/* Inner wrapper owns the flex layout — Safari/WebKit doesn't reliably treat a
                    <button> itself as a flex container. */}
                <div className="doctor-card-inner">
                  <div className="doctor-photo">
                    {/* Real <img> (not a background-image div) so it has intrinsic height and never
                        collapses on older WebKit even without aspect-ratio support. */}
                    <img className="doctor-photo-img" src={d.photo} alt="" loading="lazy" />
                    <div className={`doctor-avail ${d.available ? "" : "busy"}`}>
                      <span className="dot" />
                      {d.available ? "Available now" : "Today at 3:00 PM"}
                    </div>
                  </div>
                  <div className="doctor-info">
                    <div className="doctor-name">{d.name}</div>
                    <div className="doctor-specialty">{d.specialty}</div>
                    <div className="doctor-meta">
                      <span className="doctor-rating">
                        <Star />
                        <strong>{d.rating}</strong> · {d.reviews.toLocaleString()} reviews
                      </span>
                      <span>· {d.years} yrs</span>
                    </div>
                    <div className="doctor-cta">
                      Book a visit
                      <Arrow />
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* AI CONCIERGE */}
      <section className="section section-ai">
        <div className="container">
          <div className="ai-grid">
            <div>
              <div className="eyebrow">AI Concierge</div>
              <h2 className="h-display h2" style={{ margin: "18px 0 22px" }}>An always-on <em>concierge,</em> in your pocket.</h2>
              <p className="lead">
                Meet Aria — your AI concierge. She answers questions about plans, pricing, and how
                Champion Care works, helps you get started, and routes anything medical to a real doctor.
              </p>
              <div className="ai-features">
                {AI_FEATURES.map((f) => (
                  <div className="ai-feature" key={f.title}>
                    <div className="ai-feature-icon">{f.icon}</div>
                    <div><h4>{f.title}</h4><p>{f.body}</p></div>
                  </div>
                ))}
              </div>
              <button
                className="btn btn-primary"
                style={{ marginTop: 32 }}
                onClick={() => window.dispatchEvent(new CustomEvent("aria:open"))}
              >
                Try AI Concierge
                <Arrow />
              </button>
            </div>

            <div className="ai-mock">
              <div className="ai-mock-head">
                <div className="ai-mock-avatar">A</div>
                <div className="ai-mock-meta">
                  <div className="ai-mock-name">Aria · AI Concierge</div>
                  <div className="ai-mock-status">Online</div>
                </div>
              </div>
              <div className="ai-msg bot">Hey! 👋 I'm Aria. Ask me anything about Champion Care.</div>
              <div className="ai-msg user">What's the difference between Basic and Premium?</div>
              <div className="ai-msg bot">Basic ($50/mo) is unlimited messaging and same-week visits. Premium ($100/mo) adds priority next-day scheduling and a dedicated clinician.</div>
              <div className="ai-msg user">My shoulder's been killing me — what should I do?</div>
              <div className="ai-msg bot">I can't give medical advice on that — but a Champion Care doctor can. Want to create an account and get seen?</div>
            </div>
          </div>
        </div>
      </section>

      {/* PLANS */}
      <section className="section section-plans" id="plans">
        <div className="container">
          <div className="section-head">
            <div className="eyebrow">Pricing</div>
            <h2 className="h-display h2">Plans that <em>fit your life.</em></h2>
            <p>Flexible coverage from $50/month. Cancel or pause anytime — same full network on every plan.</p>
          </div>

          <div className="plan-includes">
            <h3 className="plan-includes__title">One membership. Your <em>whole corner.</em></h3>
            <ul className="plan-includes__grid">
              <li className="incl-item">
                <span className="incl-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8.4-7 9.5C8 19.4 5 15.5 5 11V6l7-3z" /><path d="M12 9v6M9 12h6" /></svg></span>
                <span className="incl-text"><strong>Medical, Dental &amp; Vision</strong> — three specialties, one card <span className="incl-new">New</span></span>
              </li>
              <li className="incl-item">
                <span className="incl-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12a8 8 0 0 1 16 0" /><rect x="2" y="12" width="4" height="7" rx="2" /><rect x="18" y="12" width="4" height="7" rx="2" /></svg></span>
                <span className="incl-text"><strong>Aria, your AI concierge</strong> — book, ask, and navigate, 24/7</span>
              </li>
              <li className="incl-item">
                <span className="incl-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="11" width="16" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></svg></span>
                <span className="incl-text"><strong>Encrypted messaging</strong> with your care team</span>
              </li>
              <li className="incl-item">
                <span className="incl-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(45 12 12)" /><path d="M8.5 8.5l7 7" /></svg></span>
                <span className="incl-text"><strong>Pharmacy</strong> — prescriptions delivered or ready for pickup</span>
              </li>
              <li className="incl-item">
                <span className="incl-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 3v7a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V3" /><path d="M6 12v9" /><path d="M17 3c-1.6 0-3 1.8-3 4.5V12h3V3z" /><path d="M17 12v9" /></svg></span>
                <span className="incl-text"><strong>Meal prep by Snap Kitchen</strong> — chef-made, macro-tracked fuel <span className="incl-new">New</span></span>
              </li>
              <li className="incl-item">
                <span className="incl-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2.5" y="5.5" width="13" height="9" rx="2" /><path d="M8 18.5h9a2 2 0 0 0 2-2v-7" /></svg></span>
                <span className="incl-text"><strong>Fight Club</strong> — collect UFC fighter cards</span>
              </li>
              <li className="incl-item">
                <span className="incl-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="9" r="5" /><path d="M8.5 13.2L7 21l5-2.4L17 21l-1.5-7.8" /></svg></span>
                <span className="incl-text"><strong>Combat-sports-credentialed physicians</strong> — care that speaks your sport</span>
              </li>
            </ul>
          </div>

          <div className="plans-grid">
            {TIER_PLANS.filter((p) => !p.inviteOnly).map((plan) => (
              <PlanCard key={plan.tier} plan={plan} />
            ))}
          </div>
          <p style={{ textAlign: "center", fontSize: "13.5px", color: "var(--muted)", marginTop: 32 }}>
            Both plans include the full 250-MD network. Switch or pause anytime, no hidden fees.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="section">
        <div className="container">
          <div className="section-head">
            <div className="eyebrow">Patient stories</div>
            <h2 className="h-display h2">Real care. <em>Real results.</em></h2>
          </div>
          <div className="testimonials-grid">
            {TESTIMONIALS.map((t) => (
              <div className="testimonial" key={t.name}>
                <div className="testimonial-stars">
                  {Array.from({ length: 5 }).map((_, i) => <Star key={i} />)}
                </div>
                <p className="testimonial-quote">{t.quote}</p>
                <div className="testimonial-attr">
                  <div className="testimonial-avatar">{t.initials}</div>
                  <div>
                    <div className="testimonial-name">{t.name}</div>
                    <div className="testimonial-detail">{t.detail}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section section-faq" id="faq">
        <div className="container">
          <div className="section-head">
            <div className="eyebrow">Frequently asked</div>
            <h2 className="h-display h2">Questions, <em>answered.</em></h2>
          </div>
          <div className="faq-list">
            {FAQS.map((f) => (
              <details className="faq-item" key={f.q}>
                <summary>{f.q}<Chevron /></summary>
                <div className="faq-answer">{f.a}</div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="section section-cta">
        <div className="container section-cta-inner">
          <h2 className="h-display h2">Care that's worth showing up for. <em>Yours.</em></h2>
          <p>Start a visit today — most members are seen in under 15 minutes.</p>
          <div>
            <button className="btn btn-primary btn-lg" onClick={() => navigate("/signup")}>
              Start your visit
              <Arrow />
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
